export default "__VITE_ASSET__DseWbQBe__"